import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SyncAvailableReactionsRequest } from '@cash-web/shared-util-protos/squareup/cash/cashreactions/api/v1/service_admin.pb'
import { SyncAvailableReactionsResponse } from '@cash-web/shared-util-protos/squareup/cash/cashreactions/api/v1/service_admin.pb'

export const syncAvailableReactions = (request: SyncAvailableReactionsRequest, options?: CashRequestOptions) =>
  post<SyncAvailableReactionsRequest, SyncAvailableReactionsResponse>('/2.0/cash/sync-available-reactions', request, {
    ...options,
    rejectOnError: true,
  })
